import { render, staticRenderFns } from "./middleware-game-row.vue?vue&type=template&id=8deaf9a6&scoped=true"
import script from "./middleware-game-row.vue?vue&type=script&lang=js"
export * from "./middleware-game-row.vue?vue&type=script&lang=js"
import style0 from "./middleware-game-row.vue?vue&type=style&index=0&id=8deaf9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deaf9a6",
  null
  
)

export default component.exports